import {getBackendURL, httpResponse} from "../../fn";
import axios from "axios";

/**
 * Получить список платежей по сделке
 * @param dealId
 * @returns {HttpResponseError|{participantsDocuments: {documents, fio, participantId,signProcessId,signature,type,xmls}}}
 */
export const getDealPayments = async (dealId) => {
  return await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/payments/deal/${dealId}`, {
      withCredentials: true,
      headers: {
        'content-type': 'application/json',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}